import { FC, useContext, useMemo } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import {
  AuthenticationContext,
  HeroConversationMessage,
} from '@vs-online-only-app/state';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';
import { ActionIconArrowRightSmall } from '@vs-online-only-app/ui';

type Props = {
  message: HeroConversationMessage;
};

const AssociateTransferMessage: FC<Props> = ({ message }) => {
  const { user: associate } = useContext(AuthenticationContext);
  const conversation = useSelectedHeroConversation();
  const transferredFromAssociateId = message.attributes.data.transferredFrom;

  const messageBody = useMemo(() => {
    if (associate?.username === transferredFromAssociateId) {
      return 'You transferred this chat.';
    }
    const authorFirstName = conversation?.participants.find(
      (participant) => participant.username === message.author
    )?.firstName;
    return authorFirstName ? `${authorFirstName} transferred this chat.` : '';
  }, [transferredFromAssociateId, associate, conversation, message.author]);

  if (!messageBody) {
    return null;
  }

  return (
    <>
      <Box minHeight={(theme) => theme.spacing(2)} />
      <Stack justifyContent="center">
        <Chip
          label={
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              <ActionIconArrowRightSmall />
              <Typography variant="body2">{messageBody}</Typography>
            </Stack>
          }
        />
      </Stack>
      <Box minHeight={(theme) => theme.spacing(2)} />
    </>
  );
};

export default AssociateTransferMessage;
